export default {
  seat: {
    parenthesis: '（{{text}}）',
    header: {
      station: '請輸入訂購資訊',
      seat: '請選擇座位',
      start: '{{time}}出發',
      confirm: '確認',
      seatConfirm: '座位確認',
      reserveConfirm: '預訂內容確認',
      changeConfirm: '預訂變更內容確認',
      bookingConfirm: '※僅在支付完成且預訂完成後，座位才會正式確認。'
    },
    button: {
      back: '回退',
      prev: '上一步',
      next: '下一步',
      change: '變更'
    },
    confirmCommon: {
      noticeTitle: '座位確認',
      notice1: '※預訂完成或變更手續完成後才會正式確保座位。',
      notice2: '目前座位尚未確保。',
      outbound: '去程',
      inbound: '回程',
      seatLine: '{{carNo}}號車廂-{{seatNo}}',
      departureStation: '{{station}}出發',
      arrivalStation: '{{station}}到達'
    },
    confirmChange: {
      instruction: '如內容無誤，請點擊「變更」。',
      contentLabel: '變更內容',
      before: '變更前',
      after: '變更後',
      noChange: '無變更'
    },
    confirmReserve: {
      contentLabel: '預訂內容'
    },
    selectSeatType: {
      title: '選位方法',
      auto: '電腦選位',
      manual: '自行選位'
    },
    station: {
      date: '乘車日',
      startStation: '出發站',
      endStation: '抵達站',
      selectTip: '請選擇{{name}}'
    },
    train: {
      header: '請選擇小火車',
      emptySeat: '空座位',
      wheelchairAvailable: '輪椅空間可用',
      wheelchairUnavailable: '輪椅空間不可用',
      noTrains: '沒有可購買的列車。請確認運行資訊。',
      trainLabel: '{{trainName}}{{trainServiceNo}}號'
    },
    carriage: {
      carriageCar: '{{carNo}}號車廂',
      directionUpTitle: '↑ 往宇奈月方向',
      directionDownTitle: '↑ 往欅平方向',
      conductor: '乘務員席'
    },
    wheelchairConfirm: {
      title: '您已選擇輪椅專用空間。',
      content: '此空間為輪椅乘客專用。',
      notice1: '每2個輪椅位最多可陪同1人。',
      confirmText: '是否要繼續選擇？',
      cancel: '取消',
      confirm: '確定'
    }
  },
  error: {
    invalidParams: '指定的條件有誤。請從頭重新操作',
    invalidDate: '無法選擇該日期',
    lineIdInvalid: '未選擇路線。請從頭重新操作',
    productIdInvalid: '選擇的車廂類型不正確。 請從頭開始重新操作',
    forbidden: '此操作不允許。請從頭重新操作',
    seatChangeCountExceeded: '座席變更次數限制為2次',
    notFound: '找不到頁面。請從頭重新操作',
    notFoundTitle: '找不到頁面。',
    notFoundDescription: '請確認 URL 是否正確。',
    systemError: '系統錯誤。 請稍後再試'
  }
};
